/* eslint-disable react/require-default-props */
import React from 'react';
import ToolButton from 'components/atoms/tool_button';

interface ItemToolsProps {
  enabledButtons: boolean;
  showShareButton?: boolean;
  showGenerateXlsxButton?: boolean;
  showGenerateDocxButton?: boolean;
  showPrintButton?: boolean;
  showDeleteButton?: boolean;
  showReactivateButton?: boolean;
  showFinishButton?: boolean;
  showUpdateStatusButton?: boolean;
  showMarkAsReadButton?: boolean;
  biddings_manageds?: boolean;
  biddings_finished?: boolean;
  biddings_progress?: boolean;
  biddings_tasks?: boolean;
  disabledPopoverLabel: string;
  downloadFile: (
    fileExtension: string,
    biddings_manageds: boolean,
    biddings_finished: boolean,
    biddings_progress: boolean,
    biddings_tasks: boolean,
  ) => void;
  handleShare: () => void;
  handlePrint: () => void;
  handleDelete?: () => void;
  handleReactivate?: () => void;
  handleFinish?: () => void;
  handleUpdateStatus?: () => void;
  handleMarkAsRead?: () => void;
}

const ItemTools = (props: ItemToolsProps) => {
  const {
    enabledButtons = false,
    showShareButton = true,
    showGenerateXlsxButton = true,
    showGenerateDocxButton = true,
    showPrintButton = true,
    showDeleteButton = false,
    showReactivateButton = false,
    showFinishButton = false,
    showUpdateStatusButton = false,
    showMarkAsReadButton = false,
    biddings_manageds = false,
    biddings_finished = false,
    biddings_progress = false,
    biddings_tasks = false,
    disabledPopoverLabel,
    downloadFile,
    handleShare,
    handlePrint,
    handleDelete,
    handleReactivate,
    handleFinish,
    handleUpdateStatus,
    handleMarkAsRead,
  } = props;

  return (
    <div className="col-md-6 d-flex justify-content-md-end justify-content-center mb-md-0 mb-3 flex-wrap d-print-none align-items-center">
      {showShareButton && (
        <ToolButton
          buttonClass="btn btn-primary btn-sm mr-1 mb-md-0 mb-1"
          buttonName="Compartilhar"
          disabledPopoverText={`Selecione pelo menos um${disabledPopoverLabel}`}
          disabledButton={enabledButtons}
          onButtonClick={() => handleShare()}
        />
      )}
      {showGenerateXlsxButton && (
        <ToolButton
          buttonClass="btn btn-primary btn-sm mr-1 mb-md-0 mb-1"
          buttonName="Gerar .xlsx"
          disabledPopoverText={`Selecione pelo menos um${disabledPopoverLabel}`}
          disabledButton={enabledButtons}
          onButtonClick={() =>
            downloadFile(
              'xlsx',
              biddings_manageds,
              biddings_finished,
              biddings_progress,
              biddings_tasks,
            )
          }
        />
      )}
      {showGenerateDocxButton && (
        <ToolButton
          buttonClass="btn btn-primary btn-sm mr-1 mb-md-0 mb-1"
          buttonName="Gerar .docx"
          disabledPopoverText={`Selecione pelo menos um${disabledPopoverLabel}`}
          disabledButton={enabledButtons}
          onButtonClick={() =>
            downloadFile(
              'docx',
              biddings_manageds,
              biddings_finished,
              biddings_progress,
              biddings_tasks,
            )
          }
        />
      )}
      {showPrintButton && (
        <ToolButton
          buttonClass="btn btn-primary btn-sm mr-1 mb-md-0 mb-1"
          buttonName="Imprimir"
          disabledPopoverText={`Selecione pelo menos um${disabledPopoverLabel}`}
          disabledButton={enabledButtons}
          onButtonClick={() => handlePrint()}
        />
      )}
      {showReactivateButton && handleReactivate && (
        <ToolButton
          buttonClass="btn btn-success btn-sm mr-1 mb-md-0 mb-1"
          buttonName="Reativar"
          disabledPopoverText={`Selecione pelo menos um${disabledPopoverLabel}`}
          disabledButton={enabledButtons}
          onButtonClick={() => handleReactivate()}
        />
      )}
      {showFinishButton && handleFinish && (
        <ToolButton
          buttonClass="btn btn-warning btn-sm mr-1 mb-md-0 mb-1"
          buttonName="Finalizar"
          disabledPopoverText={`Selecione pelo menos um${disabledPopoverLabel}`}
          disabledButton={enabledButtons}
          onButtonClick={() => handleFinish()}
        />
      )}
      {showUpdateStatusButton && handleUpdateStatus && (
        <ToolButton
          buttonClass="btn btn-info btn-sm mr-1 mb-md-0 mb-1"
          buttonName="Alterar"
          disabledPopoverText={`Selecione pelo menos um${disabledPopoverLabel}`}
          disabledButton={enabledButtons}
          onButtonClick={() => handleUpdateStatus()}
        />
      )}
      {showMarkAsReadButton && handleMarkAsRead && (
        <ToolButton
          buttonClass="btn btn-info btn-sm mr-1 mb-md-0 mb-1"
          buttonName="Marcar como"
          disabledPopoverText={`Selecione pelo menos um${disabledPopoverLabel}`}
          disabledButton={enabledButtons}
          onButtonClick={() => handleMarkAsRead()}
        />
      )}
      {showDeleteButton && handleDelete && (
        <ToolButton
          buttonClass="btn btn-danger btn-sm mr-1 mb-md-0 mb-1"
          buttonName="Excluir"
          disabledPopoverText={`Selecione pelo menos um${disabledPopoverLabel}`}
          disabledButton={enabledButtons}
          onButtonClick={() => handleDelete()}
        />
      )}
    </div>
  );
};

export default ItemTools;
